<template>
    <div class="">
        <div :class="[loading || form.loading ?  'active' : '']" class="dimmer">
            <div class="loader"></div>
            <div class="dimmer-content">
                <div class="row justify-content-center">
                    <div class="p-4">
                        <PaymentSettings :corporate="corporate" class="mb-4"/>
                        <BillerLookup :corporate="corporate"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Form from "../../../../core/forms/form";
import BillerLookup from "./BillerLookup.vue";
import PaymentSettings from "./PaymentSettings.vue";

export default {
    name: "Index",
    components: {BillerLookup, PaymentSettings},
    metaInfo: {
        title: 'Biller Settings'
    },
    data() {
        return {
            corporate: null,
            loading: false,
            form: new Form({
                name: '',
                industry: '',
                address: '',
                city: '',
                contact_name: '',
                contact_email: '',
                contact_phone: '',
                contact_last_name: '',
                corporate_logo : '',
            }, {}),
        };
    },

    mounted() {
        this.init();
    },

    methods: {

        init() {
            this.loading = true;
            window.axios.get(`/business/settings/api`).then((response) => {
                this.corporate = response.data.body.model.id;
                this.loading = false;
            });

        }

    }
}
</script>
